import { AppLayoutHeaderWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Header/HeaderWrapper";
import { NavigationMenuItemsDesktop } from "./Navigation/NavigationMenuItems";
import { AppLayoutWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Wrapper";
import { AppLayoutHeaderDesktop } from "./Header/AppLayoutHeader";
import { AppLayoutInnerWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/InnerWrapper";
import { AppLayoutPageWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/PageWrapper";
import { NavigationMenuItemsWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItemsWrapper";
import { RecentlyViewedSectionDesktop } from "@src/containers/redesign/AppLayout/Desktop/Navigation/RecentlyViewedSection";
import { AllRoutes } from "../Shared/Navigation/routes/AllRoutes";
import { CurrentlyViewedSectionDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/CurrentlyViewedSection";

export interface AppLayoutDesktopProps {
  admin: boolean;
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  userName: string;
  userId: string;
  logoutConfirm: () => void;
  renderStartPage: () => JSX.Element | null;
}

export function AppLayoutDesktop(props: AppLayoutDesktopProps) {
  const {
    admin,
    isAdmin,
    isWorker,
    isWorkplace,
    userName,
    userId,
    logoutConfirm,
    renderStartPage,
  } = props;

  return (
    <AppLayoutWrapperDesktop>
      <AppLayoutHeaderWrapperDesktop>
        <AppLayoutHeaderDesktop logoutConfirm={logoutConfirm} />
      </AppLayoutHeaderWrapperDesktop>
      <AppLayoutInnerWrapperDesktop>
        <NavigationMenuItemsWrapperDesktop>
          <NavigationMenuItemsDesktop
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
          />
          <CurrentlyViewedSectionDesktop
            admin={admin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            currentName={userName}
            currentUserId={userId}
          ></CurrentlyViewedSectionDesktop>
          <RecentlyViewedSectionDesktop admin={admin} />
        </NavigationMenuItemsWrapperDesktop>
        <AppLayoutPageWrapperDesktop>
          <AllRoutes
            admin={admin}
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            renderStartPage={renderStartPage}
          />
        </AppLayoutPageWrapperDesktop>
      </AppLayoutInnerWrapperDesktop>
    </AppLayoutWrapperDesktop>
  );
}
